import api from 'api'

/**
 * Feeds de notificação. A API guarda dois, separados por público: o do
 * comprador (`consumer`, o padrão, o mesmo do app) e o do painel do produtor
 * (`producer`). A mesma conta pode ter os dois, então toda chamada diz de qual
 * feed fala — lista, contador e "marcar como lidas" precisam concordar, senão
 * abrir o painel zeraria o sino da carteira.
 *
 * Todas exigem login: um 401 derruba a sessão (ver o interceptor em `api`),
 * então quem chama confere `isAuth` antes.
 */
export const AUDIENCE = {
    CONSUMER: 'consumer',
    PRODUCER: 'producer',
}

const notifications = {
    // Paginado (20), mais recentes primeiro: `data` + `meta` (`current_page`,
    // `last_page`, `total` e `unread`).
    list: (audience = AUDIENCE.CONSUMER, page = 1) => api().get('/notifications', { params: { audience, page } }),

    // { unread } — só o número, para o contador do sino.
    unreadCount: (audience = AUDIENCE.CONSUMER) => api().get('/notifications/unread-count', { params: { audience } }),

    // Marca todas do feed como lidas. { read } = quantas mudaram.
    readAll: (audience = AUDIENCE.CONSUMER) => api().post('/notifications/read-all', null, { params: { audience } }),
}

export default notifications
